/**
 * MobileTabBar — Batch #14.289 (mobile) : barre d'onglets fixe en bas de l'écran (admin, < lg).
 * Batch #14.322 — Accueil et Menu fixes ; raccourcis du milieu choisis dans Paramètres › Barre mobile (`settings.mobile_tabs`).
 */
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Menu } from "lucide-react";
import { ADMIN_MOBILE_DEFAULT, ADMIN_MOBILE_MAX, ADMIN_MOBILE_TABS, resolveTabs } from "@/constants/mobileTabs";

export default function MobileTabBar({ onSearch, onMenu, colors, tabIds }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabs = resolveTabs(ADMIN_MOBILE_TABS, tabIds, ADMIN_MOBILE_DEFAULT, ADMIN_MOBILE_MAX);
  const Item = ({ id, label, icon: Icon, active, onClick }) => (
    <button onClick={onClick} className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-1.5 min-h-[52px] text-[10px] font-medium transition active:scale-95 ${active ? "text-white" : "text-white/60"}`}
      aria-label={label} aria-current={active ? "page" : undefined} data-testid={`mobile-tab-${id}`}>
      <span className={`w-9 h-6 rounded-full flex items-center justify-center transition ${active ? "bg-white/20" : ""}`}><Icon className="w-[18px] h-[18px]" /></span>
      {label}
    </button>
  );
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 pb-safe shadow-[0_-4px_16px_rgba(0,0,0,.18)]"
      style={{ background: `linear-gradient(135deg, ${colors.cDark}, ${colors.cMed})` }} data-testid="mobile-tab-bar">
      <div className="flex items-stretch">
        <Item id="home" label="Accueil" icon={Home} active={pathname === "/admin" || pathname === "/admin/"} onClick={() => navigate("/admin")} />
        {tabs.map((t) => (
          <Item key={t.id} id={t.id} label={t.label} icon={t.icon} active={t.match ? t.match(pathname) : false}
            onClick={() => (t.action === "search" ? onSearch() : navigate(t.path))} />
        ))}
        <Item id="menu" label="Menu" icon={Menu} onClick={onMenu} />
      </div>
    </nav>
  );
}
